<template>
    <div class="container-lg topflop">
        <div v-if="axeData && !alreadyAnswered">
            <h1 class="text-center text-white">Axe {{ axeData.ordre }} : {{ axeData.axe }}</h1>
            <div class="text-center">
                <div class="accordion accordion-flush border rounded my-3 py-0--5 w-100" id="accordionResult">
                    <div class="accordion-item">
                        <h2 class="accordion-header" v-bind:id="`headingTop`">
                            <button
                                class="accordion-button d-flex flex-wrap align-items-baseline"
                                type="button"
                                data-bs-toggle="collapse"
                                v-bind:data-bs-target="`#Top`"
                                aria-expanded="true"
                                v-bind:aria-controls="`collapseTop`"
                            >
                                <span class="text-nowrap me-2 text-success fw-bold">
                                    <i class="fa-solid fa-thumbs-up me-3"></i>
                                    Je choisis mon top
                                </span>
                            </button>
                        </h2>
                        <div
                            v-bind:id="`Top`"
                            class="accordion-collapse collapse show"
                            v-bind:aria-labelledby="`headingTop`"
                            data-bs-parent="#accordionResult"
                        >
                            <div class="accordion-body text-italic d-flex flex-column">
                                <div v-for="(item, i) in axeData.leviers" v-bind:key="`top${item.id}`">
                                    <div
                                        class="d-flex align-items-center justify-content-between cursor-pointer"
                                        v-on:click="() => selectTop(item.id)"
                                    >
                                        <div class="small text-start">{{ item.label }}</div>
                                        <!-- <i class="fa-solid fa-thumbs-up"></i> -->
                                        <i
                                            v-bind:class="
                                                item.id == answer.topId
                                                    ? 'fa-solid text-success'
                                                    : 'fa-regular text-gray-500'
                                            "
                                            class="fa-thumbs-up fa-lg"
                                        >
                                        </i>
                                    </div>
                                    <!-- <div>{{ item.day1 }}</div> -->
                                    <hr v-if="i < axeData.leviers.length - 1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="accordion accordion-flush border rounded my-3 py-0--5 w-100" id="accordionResult">
                    <div class="accordion-item">
                        <h2 class="accordion-header" v-bind:id="`headingFlop`">
                            <button
                                class="accordion-button d-flex flex-wrap align-items-baseline"
                                type="button"
                                data-bs-toggle="collapse"
                                v-bind:data-bs-target="`#Flop`"
                                aria-expanded="true"
                                v-bind:aria-controls="`collapseFlop`"
                            >
                                <span class="text-nowrap me-2 text-danger fw-bold">
                                    <i class="fa-solid fa-thumbs-down me-3"></i>
                                    Je choisis mon flop
                                </span>
                            </button>
                        </h2>
                        <div
                            v-bind:id="`Flop`"
                            class="accordion-collapse collapse show"
                            v-bind:aria-labelledby="`headingFlop`"
                            data-bs-parent="#accordionResult"
                        >
                            <div class="accordion-body text-italic d-flex flex-column">
                                <div v-for="(item, i) in axeData.leviers" v-bind:key="`flop${item.id}`">
                                    <div
                                        class="d-flex align-items-center justify-content-between cursor-pointer"
                                        v-on:click="() => selectFlop(item.id)"
                                    >
                                        <div class="small text-start">{{ item.label }}</div>
                                        <i
                                            v-bind:class="
                                                item.id == answer.flopId
                                                    ? 'fa-solid text-danger'
                                                    : 'fa-regular text-gray-500'
                                            "
                                            class="fa-thumbs-down fa-lg"
                                        >
                                        </i>
                                    </div>
                                    <hr v-if="i < axeData.leviers.length - 1" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    class="btn btn-lg btn-primary"
                    v-on:click="validate"
                    v-bind:disabled="answer.topId == 0 || answer.flopId == 0"
                >
                    <i class="fa-solid fa-check me-2" />
                    Valider
                </button>
            </div>
        </div>
        <ConfirmAnsweredView v-if="alreadyAnswered" />
    </div>
</template>

<script>
import authService from "../services/authService";
import loaderService from "../services/loaderService";
import router from "../plugins/router";
import { getActiveOldAxeFunction, saveTopFlopFunction } from "../plugins/firebase";
import ConfirmAnsweredView from "./_ConfirmAnsweredView.vue";

export default {
    components: {
        ConfirmAnsweredView,
    },
    props: {
        axeId: null,
    },
    data() {
        return {
            axeData: null,
            answer: {},
            alreadyAnswered: false,
        };
    },
    async created() {
        loaderService.showLoader();
        if (this.axeId) {
            await getActiveOldAxeFunction({ axeId: this.axeId, token: authService.getToken() })
                .then((result) => {
                    const data = result.data;
                    if (data.alreadyAnswered) this.alreadyAnswered = true;
                    else {
                        this.axeData = data;
                        this.answer = { axeId: data.id, topId: 0, flopId: 0 };
                    }
                })
                .catch(function (error) {
                    console.error("Une erreur est survenue", error.code, error.message, error.details);
                });
        }
        loaderService.hideLoader();
    },
    methods: {
        selectTop(levierId) {
            this.answer.topId = levierId;
        },
        selectFlop(levierId) {
            this.answer.flopId = levierId;
        },
        async validate() {
            loaderService.showLoader();
            await saveTopFlopFunction({ token: authService.getToken(), answer: this.answer })
                .then((result) => {
                    const data = result.data;
                    if (data) {
                        this.alreadyAnswered = true;
                    } else {
                        alert("Impossible de sauvegarder votre réponse");
                        router.push({ name: "home" });
                    }
                })
                .catch((error) => {
                    const code = error.code;
                    const message = error.message;
                    const details = error.details;
                    console.log(code, message, details);
                    alert("Impossible de sauvegarder votre réponse");
                });
            loaderService.hideLoader();
        },
    },
};
</script>
